import { Stack } from '@ltvco/refresh-lib/theme';
import { MonitoringOverview, useSriracha } from '@ltvco/refresh-lib/v2';

export function Monitoring() {
  const { data } = useSriracha();
  const notifications = data || [];

  return (
    <Stack p={{ xs: 2, sm: 0 }}>
      <MonitoringOverview notifications={notifications} />
    </Stack>
  );
}
